import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import { InboxSmartInsightsResponse } from 'src/services/__generated__/api'

interface UseGetInboxSmartInsightsParams {
  fromDate?: string
  pageId: string
  toDate?: string
}

export const useGetInboxSmartInsightsQuery = (
  params: UseGetInboxSmartInsightsParams
) => {
  return useQuery<InboxSmartInsightsResponse | null>({
    enabled: !!params.pageId,
    queryFn: async () => {
      const { data } =
        await AnalyticsApi.v1Private.inboxAnalysisSmartInsightsList(
          {
            fromDate: params.fromDate,
            pageId: params.pageId,
            toDate: params.toDate,
          },
          { format: 'json' }
        )
      return data as InboxSmartInsightsResponse
    },
    queryKey: [
      QueryKey.GET_INBOX_SMART_INSIGHTS,
      params.pageId,
      params.fromDate,
      params.toDate,
    ],
  })
}
